// extracted by mini-css-extract-plugin
export var root = "Pagination-module--root--ouYef";
export var prev = "Pagination-module--prev--1_3Vn";
export var next = "Pagination-module--next--3Cg_9";
export var mobileLine = "Pagination-module--mobileLine--3_wFq";